import type { ServiceOrderState } from '@horology/shared-types';
import { api } from '../../lib/api';

export interface KpisDTO {
  today: { salesTotal: number; invoiceCount: number };
  month: { salesTotal: number; invoiceCount: number };
  serviceOrders: Partial<Record<ServiceOrderState, number>>;
  lowStockCount: number;
  dianPending: number;
  recentInvoices: Array<{
    id: number;
    number: string;
    total: number;
    status: string;
    issuedAt: string;
    customer: string;
  }>;
}

export async function getKpis(): Promise<KpisDTO> {
  const { data } = await api.get<KpisDTO>('/api/dashboard/kpis');
  return data;
}
